declare var window:WindowMU
const Backbone = require('backbone')
const {BreadCrumb} = require('./breadcrumb.ts')
declare var ReadOnlyController:any
const {parametroSistema} = require('./app/controllers/parametros/parametroController.js')
import { removerBreadcrumb2, removerBreadcrumbOriginal } from 'app/components/breadcrumb2/breadcrumb2Utils'
import { removerComponenteReact, renderizarComponentReact } from 'app/components/renderizarOuRemoverComponentReact'
import { ControllerLegado, ControllerLegadoShowViewArgs } from 'app/types/ControllerLegado'
import { WindowMU } from 'app/types/WindowMU'
import globalMU from 'globalMU'
import global from 'globalMU'
const _ = require('underscore')
const jQuery = require('jquery')
const ko = require('knockout')

const ControllerBase:any = function (options) {
    _.extend(this, options);


    this.app = !this.app ? new Backbone.Marionette.Application() : this.app;
    this.rm = this.app._regionManager;
    this.breadcrumb = !this.breadcrumb ? BreadCrumb.getInstance() : this.breadcrumb;
    this.actionButtons = new Array();
    this.readOnlyController = new ReadOnlyController($.extend({ controller: this }, options));
    this.currentReactElementId = null

    this.addRegion = function (region) {

        if (!region) {
            return null;
        }
        var regionInstance = this.getRegion(region.name);

        if (regionInstance) {
            return regionInstance;
        }

        regionInstance = this.rm.addRegion(region.name, region.selector);
        regionInstance.name = region.name;
        regionInstance.modal = region.modal;
        return regionInstance;
    };

    this.getRegion = function (name) {

        if (!name) {
            return null;
        }

        var region = this.app.getRegion(name);

        if (!region) {
            return null;
        }

        region.$el = $(region.options.el);
        return region;
    };

    this.getRegionWithSameUrl = function (url) {

        if (!url) {
            return null;
        }

        for (var r in this.rm._regions) {

            var rg = this.rm._regions[r];

            if (rg && rg.url && rg.url == url) {
                return rg;
            }
        }

        return null;

    };

    this.resetRegion = function (name) {

        var region = this.getRegion(name);

        if (!region) {
            return;
        }

        region.reset();

    };

    this.clearRegion = function () {

        if (!this.region) {
            return;
        }

        this.region.$el.empty();

    };


    this.show = function (regionName) {

        var regionId;

        if (regionName) {

            var region = this.getRegion(regionName);

            if (!region) {
                return;
            }
            region.$el.show();
            regionId = region.el.options;

        } else {
            var $region;

            if (this.container) {
                $region = $('[region="main"]', $(this.container));
            } else if (typeof this.region == "string") {
                $region = $('[region="main"]', $(this.region));
            } else {
                $region = $('[region="main"]');
            }

            $region.siblings("[region]").hide();
            $region.show();
            regionId = $region.attr("id");
        }

        this.breadcrumb.update(regionId, false);
        this.renderActionButtons();
    };

    this.addStack = function (item) {

        if (!this.stack) {
            this.stack = new Array();
        }

        this.stack.push(item);

    };

    this.aplicarAspectos = function (instance) {

        $.aop.before({ target: instance, method: "render" },
            function () {
                var el = $(":focus");
                this.focusedElementId = el.attr("id");
                this.focusedElementName = el.attr("name");

            });

        $.aop.after({ target: instance, method: "render" },
            function () {
                parametroSistema.aplicarParametros(this.$el);
                global.applyMasks(this.$el);

                if (this.controller && this.controller.applyReadOnly) {
                    this.controller.applyReadOnly();
                }

                if (this.focusedElementId || this.focusedElementName) {

                    var focusElement = this.focusedElementId
                        ? $("#" + this.focusedElementId)
                        : $("[name=" + this.focusedElementName + "]");

                    setTimeout($.proxy(function () {
                        focusElement.focus();
                    },
                        this),
                        100);
                }

            });

        $.aop.after({ target: instance, method: "_renderChildren" },
            function () {
                parametroSistema.aplicarParametros(this.$el);
            });

        $.aop.after({ target: instance, method: "_onCollectionAdd" },
            function () {
                parametroSistema.aplicarParametros(this.$el);
            });

        var self = this;

        $.aop.after({ target: instance, method: "buildChildView" },
            function (result) {

                self.aplicarAspectos(result);

                return result;
            });

    };

    this.showView = function (args: ControllerLegadoShowViewArgs) {

        var self = this;

        if (!args) {
            throw "Argumentos não informados.";
        }

        if (globalMU.isNotNullOrEmpty(this.currentReactElementId)) {
            if (args.acaoParaComponenteReact == "REMOVER") {
                removerComponenteReact(this.currentReactElementId)    
            }

            if (args.acaoParaComponenteReact == "ESCONDER") {
                document.getElementById(globalMU.removerSharpDeIdDeElemento(this.currentReactElementId)).style.display = "none"
            }
        }

        var region = null;

        if (typeof args.region != "undefined") {
            region = this.addRegion(args.region);
        } else {
            throw "Region não definido";
        }

        this.currentRegion = region;

        var view = null;

        if (typeof args.view != "undefined") {
            view = args.view;
        }

        var controller = null;
        var react = null

        if (typeof args.controller != "undefined") {
            controller = args.controller;
        }

        if (typeof args.react != "undefined") {
            react = args.react
        }

        var modal = null;

        if (typeof args.modal != "undefined") {
            modal = args.modal;
        }

        // if (!this.validateBeforeToContinue())
        //     return;

        if (view) {

            view.typeName = "view";

            if (this.region) {
                var $region = this.region.options
                    ? $(this.region.options.el)
                    : $(this.region);
                $("[region]", $region).hide();
                $("[region]").has(region.$el).show();
            }

            var viewArgs = {
                app: this.app,
                parent: this,
                currentRegion: region
            };

            _.extend(viewArgs, view.args);

            view.instance = new view.type(viewArgs);
            view.instance.controller = this;

            this.aplicarAspectos(view.instance);

            if (typeof args.antesRenderizacaoCompleta != "undefined") {
                args.antesRenderizacaoCompleta();
            }

            // FNX-1241
            if (typeof view.instance.templateCache == "boolean" && !view.instance.templateCache) {
                Backbone.Marionette.TemplateCache.clear(view.instance.template)
            }
            region.reset();
            region.show(view.instance);
            region.$el.show();

            if (typeof args.showBreadCrumb == "undefined" || args.showBreadCrumb) {
                view.instance.breadcrumbItem = this.breadcrumb.add({
                    region: region,
                    view: view,
                    controller: {
                        instance: this
                    }
                });
            } else {
                this.breadcrumb.hide();
            }

            this.addStack(view);

            global.applyMasks(region.$el);


            // React 18: `unmountComponentAtNode` saiu (e no 19 nem existe mais). Passa pela ponte
            // para que a raiz criada por `createRoot` seja destruida E retirada do registro —
            // desmontar por fora deixaria o registro apontando para uma raiz morta.
            removerComponenteReact("conteudo-pagina")

            removerBreadcrumb2()

            return view.instance;
        }

        if (controller) {

            controller.typeName = "controller";

            var controllerArgs = {
                app: this.app,
                parent: this,
                breadcrumb: this.breadcrumb,
                container: args.region.selector,
                region: region,
                currentRegion: region,
                unmappedModelData: args.unmappedModelData
            };

            _.extend(controllerArgs, controller.args);

            controller.instance = new controller.type(controllerArgs);

            if (!modal) {
                ControllerBase.current = controller.instance;
            }

            if (controller.instance.name) {
                ControllerBase.instances = ControllerBase.instances ? ControllerBase.instances : {};
                ControllerBase.instances[controller.instance.name] = controller.instance;
            }

            this.addStack(controller);

            if (typeof controller.instance.ajax != "undefined") {
                var ajaxData = controller.instance.ajax();

                if (ajaxData.async == undefined) {
                    ajaxData.async = true;
                }

                ajaxData.success = function (data) {

                    if (data && !data.HasErrors) {

                        if (typeof args.actionButtons != "undefined") {
                            controller.instance.addActionButtons(args.actionButtons);
                        }

                        if (typeof controller.instance.useActionButtons == "undefined" ||
                            controller.instance.useActionButtons) {
                            controller.instance.renderActionButtons();
                        }

                        if (!modal) {
                            if (self.region) {
                                $("[region]").siblings(':not([data-breadcrumb])').hide();
                                region.$el.parents().show();
                                $("[region]").has(region.$el).show();
                            }
                        }

                        if (controller.instance.isKnockout()) {

                            var model = null;

                            if (args.model) {
                                model = args.model;
                            } else if (controller.instance.newModel) {
                                model = controller.instance.newModel();
                            }

                            if (model) {
                                controller.instance.setModel(model);
                            }
                        }

                        if (typeof controller.instance.antesRenderizado != "undefined") {
                            controller.instance.antesRenderizado();
                        }

                        var r = self.getRegionWithSameUrl(ajaxData.url);

                        if (r && r.$el) {
                            r.$el.empty();
                        }

                        region.url = ajaxData.url;
                        region.$el.empty();
                        region.$el.html(data);

                        var callback = $.proxy(self.controllerRenderizado, self, controller, region, args);
                        callback();
                    }
                };

                global.ajax(ajaxData);

            } else {
                controller.instance.renderizar($.proxy(this.controllerRenderizado, this, controller, region, args));
            }

            // React 18: `unmountComponentAtNode` saiu (e no 19 nem existe mais). Passa pela ponte
            // para que a raiz criada por `createRoot` seja destruida E retirada do registro —
            // desmontar por fora deixaria o registro apontando para uma raiz morta.
            removerComponenteReact("conteudo-pagina")

            removerBreadcrumb2()

            return controller.instance;
        }

        if (react) {

            window.alert('showView para componente chamado, isto é considerado um erro. Informações adicionais foram logadas no console')
            console.trace('chamada de showView para componente react')

            if (globalMU.isNotNullOrEmpty(this.currentReactElementId)) { 
                removerComponenteReact(this.currentReactElementId)
            }

            react.redux = react.redux == undefined ? true : react.redux

            react.typeName = 'react'
            region.$el.empty()
            

            const renderReactFn = () => renderizarComponentReact(
                react.component,
                region.$el.selector,
                react.redux
            )

            renderReactFn()


            //$("[region]").siblings(':not([data-breadcrumb])').hide()
            $("[region]").siblings(`:not(${region.$el.selector})`).hide()
            region.$el.parents().show()
            $("[region]").has(region.$el).show()
            
            
            if ($("[breadcrumb-start]", region.$el).length > 0) {
                this.breadcrumb.add({
                    region: {
                        name: region.name,
                        $el: $("[breadcrumb-start]", region.$el),
                        options: region.options,
                        isReact: true,
                        renderReactFn: renderReactFn
                    }
                });
            } else {
                this.breadcrumb.add({
                    region: {
                        ...region,
                        isReact: true,
                        renderReactFn: renderReactFn
                    },
                    
                });
            }

            this.currentReactElementId = region.$el.selector

            removerBreadcrumbOriginal()
        }

        return null;

    };

    this.mostrarComponenteReactAtual = function() {
        if (globalMU.isNotNullOrEmpty(this.currentReactElementId)) {
            document.getElementById(globalMU.removerSharpDeIdDeElemento(this.currentReactElementId)).style.display = "block"
        }
    }

    this.render = function (region) {

        if (!this.ajax) {
            return;
        }

        var ajaxData = this.ajax();
        var self = this;

        ajaxData.success = function (data) {

            if (!data) {
                return;
            }

            if (!(region instanceof jQuery)) {
                region = $(region);
            }

            region.html(data);

            var startCallback = $.proxy(self.start, self, region);

            if (self.newModel) {
                self.setModel(self.newModel());
            }

            self.applyBindings(self, region[0], startCallback);

        };

        global.ajax(ajaxData);

    };

    this.isKnockout = function () {
        return this.framework && this.framework == "knockout";
    };

    this.isKnockoutObject = function (instance) {

        if (!instance) {
            return false;
        }

        return ko.isComputed(instance) || ko.isObservable(instance);
    };

    this.isBackboneObject = function (instance) {

        if (!instance) {
            return false;
        }

        return instance instanceof Backbone.Model ||
            instance instanceof Backbone.Collection;
    };

    this.isBackbone = function () {
        return !this.framework || this.framework == "backbone";
    };

    this.controllerRenderizado = function (controller, region, args) {

        if (typeof controller.instance.antesRenderizacaoCompleta != "undefined") {
            controller.instance.antesRenderizacaoCompleta(region);
        }
        this.renderDataBreadcrumb(controller, region);
        region.$el.show();

        if (controller.instance.allowShow != undefined && !controller.instance.allowShow) {
            $("[region]", region.$el).hide();

            if (typeof controller.instance.renderizado != "undefined") {
                var callback = $.proxy(controller.instance.renderizado, controller.instance);
                callback();
            }

            return;
        }

        if (typeof args.showBreadCrumb == "undefined" || args.showBreadCrumb) {

            if ($("[breadcrumb-start]", region.$el).length > 0) {
                controller.instance.breadcrumbItem = this.breadcrumb.add({
                    region: {
                        name: region.name,
                        $el: $("[breadcrumb-start]", region.$el),
                        options: region.options
                    },
                    controller: controller
                });
            } else {
                controller.instance.breadcrumbItem = this.breadcrumb.add({
                    region: region,
                    controller: controller
                });
            }
        } else {
            this.breadcrumb.hide();
        }

        if (typeof controller.instance.renderizado != "undefined") {
            var callback = $.proxy(controller.instance.renderizado, controller.instance);
            callback();
        }

        if (controller.instance.isKnockout()) {
            ko.cleanNode(region.$el[0]);
        }

        var startCallback = $.proxy(this.start, controller.instance, region.$el);
        if (controller.instance.isKnockout()) {
            this.applyBindings(controller.instance, controller.instance.region.$el[0], startCallback);
        } else {
            startCallback();
        }

        if (typeof controller.instance.renderizacaoCompleta != "undefined") {
            var renderizacaoCompletaCallback = $.proxy(controller.instance.renderizacaoCompleta, controller.instance);
            renderizacaoCompletaCallback();
        }

    };

    this.renderDataBreadcrumb = function (controller, region) {

        if (!controller.instance.dataBreadcrumb) {
            return;
        }

        controller.instance.dataBreadcrumb.render(controller.instance, region.$el);
    };

    this.applyBindings = function (model, element, startCallback) {
        var bindingRegion;
        if (!model) {
            model = this;
        }

        bindingRegion = this.region;
        if (typeof model.bindingRegion != "undefined") {
            bindingRegion = model.bindingRegion;
            element = null;
        }


        if (!element && bindingRegion) {
            if (bindingRegion.$el) {
                element = bindingRegion.$el[0];
            } else if (bindingRegion) {
                var el = $(bindingRegion);

                if (el && el.length > 0) {
                    element = el[0];
                }
            }
        }

        if (typeof model.antesBinding != "undefined") {
            var antesBindingCallBack = $.proxy(model.antesBinding, model);
            antesBindingCallBack();
        }

        ko.cleanNode(element);
        ko.applyBindings(model, element);

        if (!startCallback) {
            startCallback = $.proxy(this.start, this, element);
        }

        startCallback();


        if (typeof model.aposBinding != "undefined") {
            var aposBindingCallBack = $.proxy(model.aposBinding, model);
            aposBindingCallBack();
        }

    };

    this.start = function (region) {

        if (region && !(region instanceof jQuery)) {
            region = $(region);
        } else if (this.region && typeof this.region == "string") {
            region = $(this.region);
        } else if (!(region instanceof jQuery)) {
            region = $("body");
        }

        parametroSistema.aplicarParametros(region);
        global.applyMasks(region);
        this.applyReadOnly();
        this.initializeForm();
        this.attachEvents();

        if (!this.breadcrumbItem) {

            if (typeof this.showBreadCrumb == "undefined" || this.showBreadCrumb) {

                if (region.is("[breadcrumb-start]") || $("[breadcrumb-start]", region).length > 0) {

                    var r = region.is("[breadcrumb-start]") ? region : $("[breadcrumb-start]", region);

                    this.breadcrumbItem = this.breadcrumb.add({
                        region: {
                            name: this.region && this.region.name ? this.region.name : null,
                            $el: r
                        },
                        controller: this
                    });
                } else {

                    var r = region.is('[breadcrumb][region="main"]')
                        ? region
                        : $('[breadcrumb][region="main"]', region);

                    this.breadcrumbItem = this.breadcrumb.add({
                        region: {
                            name: this.region && this.region.name ? this.region.name : null,
                            $el: r
                        },
                        controller: this
                    });
                }

            } else {
                this.breadcrumb.hide();
            }

        }

        this.renderActionButtons();

    };

    this.toJS = function (value) {

        if (!value) {
            return null;
        }


        if (this.isKnockoutObject(value)) {
            return ko.mapping.toJS(value);
        } else if (this.isBackboneObject(value)) {
            return value.toJSON();
        } else if (this.isKnockout()) {
            return ko.mapping.toJS(value);
        } else {
            return value;
        }
    },
        this.attachEvents = function () {

            var events = typeof this.events != "undefined" && this.events ? this.events : null;

            if (!events) {
                return;
            }


            for (var key in events) {

                var arr = key.split(" ");

                if (arr.length == 2) {
                    var $el = $(arr[1], this.region.$el);
                    $el.unbind(arr[0]);
                    $el.on(arr[0], $.proxy(this[events[key]], this));
                }
            }

        };

    this.initializeForm = function () {

        if (typeof this.formConfig == "undefined" || !this.formConfig) {
            return;
        }

        this.form = $(this.formConfig.selector);

        var self = this;

        $("[calendar] input", this.form).on("dpkeypress",
            function (e) {

                if (e.keyCode == 13 || e.which == 13) {
                    self.form.submit();
                }

            });

        if (typeof this.formConfig.rules != "undefined") {
            for (var key in this.formConfig.rules) {
                var rule = this.formConfig.rules[key];

                for (var k in rule) {
                    if (!$.isFunction(rule[k])) {
                        continue;
                    }
                    rule[k] = $.proxy(rule[k], this);
                }

            }
        }

        if (typeof this.formConfig.submit != "undefined" && this.formConfig.submit) {


            if (this.formConfig.submit.selector) {
                var $submit = $(this.formConfig.submit.selector, this.form);

                if ($submit.length > 0) {
                    $submit.click($.proxy(this.submitForm, this, 1));
                }

                if (this.formConfig.submit.submitOnEnter == undefined || this.formConfig.submit.submitOnEnter) {
                    $(this.formConfig.selector).keypress(function (e) {
                        if (e.keyCode == 13 || e.which == 13) {
                            e.preventDefault();
                            try {
                                var $focused = $(":focus");
                                $focused.trigger("change");
                                $submit.focus();
                                $submit.trigger("click");
                                $focused.focus();
                            } catch (ex) {
                            }
                            return false;
                        }
                    });
                }

            } else if (this.formConfig.submit.callback) {
                this.formConfig.submitHandler = $.proxy(this[this.formConfig.submit.callback], this);
            }


        }

        global.configForm(this.formConfig);


    };

    this.pageClick = function (pageData) {
        this.submitForm(pageData.page);
    };

    this.validateForm = function () {
        var $form = $(this.formConfig.selector);
        return $form.valid();
    };

    // this.validateBeforeToContinue = function () {

    //     var self = this;
    //     var isValid = true;

    //     isValid = isValid; // testeApp

    //     if (self.model) {

    //         if (self.model.OrdemAlterada) {
    //             if (!window.confirm('Deseja descartar ordenação de itens?')) {
    //                 isValid = false;

    //             } else if (typeof self.model.restaurarOrdenacao !== 'undefined' && !self.model.OrdemGravada) {
    //                 self.model.OrdemAlterada = false;
    //                 self.model.restaurarOrdenacao();

    //             }
    //         }
    //     }

    //     return isValid;
    // },

        this.submitForm = function (pagina, e) {

            var self = this;

            if (e) {
                e.preventDefault();
            }

            var $form = $(this.formConfig.selector);

            if (!$form.valid()) {
                return false;
            }

            var submitConfig = this.formConfig.submit;
            var $e = $(e.target);

            if (submitConfig.loadingText) {
                submitConfig.text = $e.html();
                $e.html(submitConfig.loadingText);
            }


            var submitCallback = typeof submitConfig.callback != "undefined" && submitConfig.callback
                ? this[submitConfig.callback]
                : null;
            var ajax = typeof this.formConfig.ajax != "undefined" && this.formConfig.ajax ? this.formConfig.ajax : null;


            if (submitConfig.beforeSubmit) {
                this[submitConfig.beforeSubmit]();
            }

            var afterSubmitCallback = null;

            if (submitConfig.afterSubmit) {
                afterSubmitCallback = $.proxy(this[submitConfig.afterSubmit], self);
            }

            var modelData = submitConfig.type == "model"
                ? (submitConfig.modelType && submitConfig.modelType == "js"
                    ? ko.mapping.toJS(this.model)
                    : this.model)
                : global.convertFormToJSON({
                    element: $form
                });

            if (submitCallback) {
                var callback = $.proxy(submitCallback, self, modelData, e);
                callback();
            }

            if (ajax) {

                var ajaxData = {};

                if (ajax.param) {
                    ajaxData[ajax.param] = modelData;
                } else {
                    ajaxData = modelData;
                }

                ajax.contentType = "application/json";
                ajax.data = global.toJSONString(ajaxData);

                ajax.success = function (data) {

                    if (submitConfig.text) {
                        $e.html(submitConfig.text);
                    }

                    if (data) {
                        global.resolveDates(data);
                    }

                    if (afterSubmitCallback) {
                        afterSubmitCallback(data);
                    }
                };

                global.ajax(ajax);
            } else {
                if (submitConfig.text) {
                    $e.html(submitConfig.text);
                }
            }
        };

    this.addActionButton = function (args, render) {

        if (this.readOnly || !args || typeof args.text == "undefined" || typeof args.click == "undefined") {
            return null;
        }

        //if (this.existActionButton(args)) {

        //    if (global.where(this.actionButtons, { text: args.text }) == 0) {
        //        this.actionButtons.push(args);
        //    }

        //    return this.getActionButton(args);
        //}

        if (global.where(this.actionButtons, { text: args.text }) == 0) {
            this.actionButtons.push(args);
        }

        if (render) {
            this.renderActionButtons();
        }

        return this.getActionButton(args);
    };

    this.getActionButtonById = function (id) {
        return $("div[action-buttons] button#" + id);
    };

    this.getActionButton = function (args) {
        return $('div[action-buttons] button:contains("' + args.text + '")');
    };

    this.existActionButton = function (args) {
        return $('div[action-buttons] button:contains("' + args.text + '")').length > 0;
    };

    this.addActionButtons = function (actionButtons) {

        if (!actionButtons || this.readOnly) {
            return;
        }

        var self = this;

        $.each(actionButtons,
            function () {
                self.addActionButton(this, false);
            });

        this.renderActionButtons();
    };

    this.renderActionButtons = function () {

        var el = $("div[action-buttons]");

        if (!el) {
            return;
        }

        if (this.currentRegion && this.currentRegion.modal) {
            return;
        }

        el.empty();

        if (this.actionButtons.length == 0) {
            el.css("height", "auto");
            return;
        }

        el.css("height", "");

        var self = this;

        $.each(this.actionButtons,
            function () {

                if (!self.existActionButton(this)) {

                    var attr = { id: this.id };

                    if (this.attr) {
                        attr = $.extend(attr, this.attr);
                    }

                    var button = $("<button>", attr);

                    if (this.class) {
                        button.addClass(this.class);
                    }

                    button.html(this.text);
                    button.click($.proxy(this.click, self));
                    el.append(button);
                }
            });


    };

    this.hide = function () {

        //if (this.breadcrumbItem) {
        //    this.breadcrumb.remove(this.breadcrumbItem);
        //}

        var self = this;

        if (this.stack && this.stack.length > 0) {
            $.each(this.stack,
                function () {

                    switch (this.typeName) {
                        case "view":

                            if (typeof this.instance.breadcrumbItem != "undefined" && this.instance.breadcrumbItem) {
                                self.breadcrumb.remove(this.instance.breadcrumbItem);
                            }

                            break;
                        case "controller":

                            this.instance.hide();

                            break;
                    }

                });
        }


        if (this.region) {

            if (this.framework == "knockout") {
                ko.cleanNode(this.region.$el[0]);
            }

            this.region.$el = $(this.region.options.el);
            this.region.$el.siblings('[region="main"]').show();
            this.region.$el.hide();

            this.breadcrumb.update(this.region.name, true);

        } else {
            this.breadcrumb.removeLast();
        }

    };

    this.createModel = function () {

        if (!this.model) {
            this.model = {};
        }

    };

    this.createObservables = function (instance, createObservables) {
        instance = createObservables || createObservables == undefined
            ? ko.mapping.fromJS(instance)
            : instance;

        var value = ko.isObservable(instance)
            ? instance()
            : instance;

        var self = this;

        if ($.isArray(value)) {
            $.each(value, function () {
                self.createObservables(this, false);
            });
        } else {
            var observable = ko.observable();

            for (var attr in value) {
                if (attr.indexOf("__") != 0 && !observable[attr]) {
                    if ($.isArray(value[attr])) {
                        value[attr] = self.createObservables(value[attr], false)
                    } else if (!ko.isObservable(value[attr])) {
                        value[attr] = ko.observable(value[attr]);
                    }
                }
                //if (attr.indexOf("__") != 0 && !ko.isObservable(value[attr]) && !observable[attr]) {
                //    value[attr] = ko.observable(value[attr]);
                //}
            }
        }

        return instance;
    };

    this.setModel = function (model) {

        if (!model && this.newModel) {
            model = this.newModel();
        }

        if (model) {
            global.resolveDates(model);
            this.model = this.createObservables(model);// ko.mapping.fromJS(model);

            if (this.unmappedModelData) {
                this.model = $.extend(this.model, this.unmappedModelData);
            }

        } else {
            this.createModel();
        }
    };

    this.appendToModel = function (args) {

        if (!args.model) {
            this.createModel();
        }

        if (args.computed) {
            this.model[args.name] = ko.computed(function () {
                return args.computed();
            },
                this);
            return;
        }

        var model = args.model ? args.model : this.model;

        if (args.value == undefined) {
            args.value = ko.observable();
        } else {

            switch (typeof args.value) {
                case "function":
                    args.value = $.proxy(args.value, model);
                    break;
                case "object":

                    args.value = ko.mapping.fromJS(args.value);

                    //if (Array.isArray(args.value)) {
                    //    //args.value = ko.observableArray(args.value);
                    //    args.value = ko.mapping.fromJS(args.value);
                    //} else {
                    //    args.value = ko.observable(args.value);
                    //}

                    break;
                default:
                    args.value = ko.observable(args.value);
            }
        }

        model[args.name] = args.value;

    };

    this.addEvent = function (name, model, eventSelector, eventHandler) {

        ControllerBase.events.addEvent(this, name, model, eventSelector, eventHandler);
    };

    this.applyReadOnly = function () {
        this.readOnlyController.applyController();
    };

    if (this.initialize) {
        this.initialize();
        $("input").on('focus', function () { $(this).select(); });
    }

};


var _extendControllerBase = function (protoProps, staticProps) {

    var parent = this;
    var child;

    if (protoProps && _.has(protoProps, "constructor")) {
        child = protoProps.constructor;
    } else {
        child = function () { return parent.apply(this, arguments); };
    }

    _.extend(child, parent, staticProps);

    var Surrogate = function () { this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;

    if (protoProps) _.extend(child.prototype, protoProps);

    child.__super__ = parent.prototype;

    return child;
};

ControllerBase.extend = _extendControllerBase;

window.ControllerBase = ControllerBase

export {ControllerBase}
